import React from 'react';
import { UseFormRegister } from 'react-hook-form';

type IProps = {
  id?: string;
  label: string;
  type?: any;
  placeholder?: string;
  errors?: any;
  isRequired?: boolean;
  defaultValue?: string | null;
  className?: string;
  register: any;
  disabled?: boolean;
  rows?: number;
};
const SelectTextArea = ({
  id,
  label,
  type = 'text',
  register,
  placeholder,
  errors,
  isRequired,
  defaultValue,
  className,
  disabled,
  rows,
}: IProps) => (
  <div>
    <label htmlFor={id} className=''>
      {label}
    </label>{' '}
    {isRequired && <span className='require'>*</span>}
    <textarea
      disabled={disabled}
      defaultValue={defaultValue}
      required={isRequired}
      id={id}
      type={type}
      {...register}
      className={`form-control ${errors ? 'is-invalid' : ''} ${className}`}
      placeholder={placeholder || label}
      rows={rows || 1}
    />
    {errors && <div className='invalid-feedback'>{errors.message}</div>}
  </div>
);

export default SelectTextArea;
